import styled, { css } from 'styled-components';
import { QuantityProps } from '.';

export const Container = styled.div<QuantityProps>`
  display: flex;
  flex-direction: ${({ $orientation }) =>
    $orientation === 'vertical' ? 'column' : 'row'};

  background-color: none;
  gap: ${({ theme }) => theme.spacing['1']}px;
`;

export const ContainerControles = styled.div<QuantityProps>`
  display: flex;
  flex-direction: row;
  align-items: center;

  background-color: ${({ theme, $variant }) => {
    if ($variant === 'ghost') return 'none';
    if ($variant === 'soft') return theme.colors.accent.accent_alpha['3'];
    return theme.tokens.colors.surface;
  }};

  border-radius: ${({ theme }) => theme.radius['3']}px;
  padding: ${({ theme }) => theme.spacing['3']}px 0px;
  gap: ${({ theme }) => theme.spacing['1']}px;
`;

export const Input = styled.input.attrs({
  type: 'text',
  maxLength: 4,
})<QuantityProps & { $size: number }>`
  display: flex;
  max-width: 40px;

  text-align: center;

  &:focus,
  &:active,
  &:hover {
    border-radius: ${({ theme }) => theme.radius['2']}px;
    border: 1px solid
      ${({ theme, $variant }) => {
        if (['surface', 'ghost'].includes($variant))
          return theme.colors.neutral.neutral_alpha['7'];
        return theme.colors.accent.accent_alpha['7'];
      }};
  }

  ${({ theme, $size }) => {
    return css`
      font-size: ${theme.typography.font.size[$size]}px;
      font-family: var(--font-${theme.typography.font.family.text});
      font-weight: ${theme.typography.font.weight.medium};
      line-height: ${theme.typography.font.line_height[$size]}px;
      color: ${theme.tokens.colors.text};
    `;
  }}
`;
